export const ROUTE_HOME = "/admin/dashboard"
export const ROUTE_CONTACTS = "/admin/contacts"
export const ROUTE_ATTENDANCE = "/admin/attendance"
export const ROUTE_AUTOMATION = "/admin/automation"
export const ROUTE_CONVERSION = "/admin/conversion"
export const ROUTE_AI = "/admin/ai"
export const ROUTE_REPORT = "/admin/report"
export const ROUTE_PLUGINS = "/admin/plugins"
export const ROUTE_ECOSYSTEM = "/admin/ecosystem"
export const ROUTE_ACCOUNT = "/admin/account"
